import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as l } from "react";
import { I as t } from "../../../../IconBase-CxZyIWw2.js";
const a = l((i, e) => /* @__PURE__ */ s.jsx(
  t,
  {
    ref: e,
    ...i,
    image: (r) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...r,
        children: [
          /* @__PURE__ */ s.jsxs("g", { clipPath: "url(#clip0_2974_4158)", children: [
            /* @__PURE__ */ s.jsx(
              "mask",
              {
                id: "mask0_2974_4158",
                width: 26,
                height: 32,
                x: 11,
                y: 8,
                maskUnits: "userSpaceOnUse",
                style: {
                  maskType: "alpha"
                },
                children: /* @__PURE__ */ s.jsx(
                  "path",
                  {
                    fill: "currentColor",
                    d: "M29.78 20.45c-1.95 0-3.99.84-5.33 2.62V9.5h11.4a.749.749 0 1 0 0-1.5h-24.1c-.41 0-.75.34-.75.75s.34.75.75.75h11.2v29.75c0 .41.34.75.75.75s.75-.34.75-.75V28.07c0-4.83 3.35-6.12 5.33-6.12 5.07 0 5.33 5.68 5.33 6.82 0 .41.34.75.75.75s.75-.34.75-.75c-.01-3.83-1.8-8.32-6.83-8.32"
                  }
                )
              }
            ),
            /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_4158)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M.01-.037h47.941v48.166H.01z" }) })
          ] }),
          /* @__PURE__ */ s.jsx("defs", { children: /* @__PURE__ */ s.jsx("clipPath", { id: "clip0_2974_4158", children: /* @__PURE__ */ s.jsx("path", { fill: "#fff", d: "M0 0h48v48H0z" }) }) })
        ]
      }
    )
  }
));
a.displayName = "AgencyTretinoinIcon";
export {
  a as AgencyTretinoinIcon,
  a as default
};
//# sourceMappingURL=index.js.map
